// roomAvailabilitySlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { frontPreBookingDetail } from "../../../Services/BON-Frontend/Service";

export const fetchPreBookingDetail = createAsyncThunk(
  "preBooking/fetchPreBookingDetail",
  async ({ PropertyID, CheckIn, CheckOut }, thunkAPI) => {
    try {
      const response = await frontPreBookingDetail(
        PropertyID,
        CheckIn,
        CheckOut
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const preBookingSlice = createSlice({
  name: "preBooking",
  initialState: {
    loading: false,
    roomDetails: [],
    preBookingDetails: [],
    table3Details: [],
    checkInDate: "",
    checkOutDate: "",
    error: null,
  },
  reducers: {
      setBookingDates: (state, action) => {
      state.checkInDate = action.payload.checkInDate;
      state.checkOutDate = action.payload.checkOutDate;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreBookingDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPreBookingDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.roomDetails = action.payload?.RatePlan || [];
        state.preBookingDetails = action.payload?.RoomDetails || [];
        state.table3Details = action.payload?.Table3 || [];
      })
      .addCase(fetchPreBookingDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const { setBookingDates } = preBookingSlice.actions;

export default preBookingSlice.reducer;
